var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.839,
    height: 45.839,
    viewBox: "0 0 45.839 45.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "access-control",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14605",
    "data-name": "Path 14605",
    d: "M19.617,39.234A19.617,19.617,0,1,1,39.234,19.617,19.412,19.412,0,0,1,37.827,26.9a2.358,2.358,0,0,1-.142.349A1.4,1.4,0,0,1,35.178,26,16.817,16.817,0,1,0,19.617,36.431a16.7,16.7,0,0,0,9.05-2.649,1.4,1.4,0,0,1,1.516,2.356,19.481,19.481,0,0,1-10.567,3.1Z",
    transform: "translate(0)",
    fill: "#ed2f59",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14606",
    "data-name": "Path 14606",
    d: "M16.808,39.234C11.308,39.234,7,30.617,7,19.617S11.308,0,16.808,0s9.808,8.617,9.808,19.617S22.309,39.234,16.808,39.234Zm0-36.431C13.5,2.8,9.8,9.707,9.8,19.617S13.5,36.431,16.808,36.431s7.006-6.9,7.006-16.815S20.122,2.8,16.808,2.8Z",
    transform: "translate(2.808)",
    fill: "#ed2f59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14607",
    "data-name": "Path 14607",
    d: "M16.808,39.234C11.308,39.234,7,30.617,7,19.617S11.308,0,16.808,0s9.808,8.617,9.808,19.617S22.309,39.234,16.808,39.234Zm0-36.431C13.5,2.8,9.8,9.707,9.8,19.617S13.5,36.431,16.808,36.431s7.006-6.9,7.006-16.815S20.122,2.8,16.808,2.8Z",
    transform: "translate(2.808)",
    fill: "#ed2f59",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14608",
    "data-name": "Path 14608",
    d: "M36.03,10.8H2.4A1.4,1.4,0,0,1,2.4,8H36.03a1.4,1.4,0,0,1,0,2.8ZM34.783,24.815H2.4a1.4,1.4,0,0,1,0-2.8H34.783a1.4,1.4,0,0,1,0,2.8Zm2.3,10.394.239.845a.522.522,0,0,1-.474.679H35.211a.522.522,0,0,1-.474-.679l.239-.845a1.65,1.65,0,0,1-.4-1.413,1.54,1.54,0,0,1,1.191-1.257A1.517,1.517,0,0,1,37.516,34.1a1.638,1.638,0,0,1-.431,1.113Z",
    transform: "translate(0.401 3.21)",
    fill: "#ed2f59",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14609",
    "data-name": "Path 14609",
    d: "M32.611,36.012H24.2a4.208,4.208,0,0,1-4.2-4.2V26.2A4.208,4.208,0,0,1,24.2,22h8.407a4.208,4.208,0,0,1,4.2,4.2v5.6A4.208,4.208,0,0,1,32.611,36.012ZM24.2,24.8a1.4,1.4,0,0,0-1.4,1.4v5.6a1.4,1.4,0,0,0,1.4,1.4h8.407a1.4,1.4,0,0,0,1.4-1.4V26.2a1.4,1.4,0,0,0-1.4-1.4Z",
    transform: "translate(8.024 8.827)",
    fill: "#ed2f59",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14610",
    "data-name": "Path 14610",
    d: "M31.808,26.461a1.4,1.4,0,0,1-1.4-1.4V23.434a2.713,2.713,0,0,0-1.771-2.593,2.911,2.911,0,0,0-3.012.642,2.781,2.781,0,0,0-.822,1.98v1.6a1.4,1.4,0,0,1-2.8,0v-1.6a5.594,5.594,0,0,1,1.652-3.971,5.651,5.651,0,0,1,5.854-1.314,5.475,5.475,0,0,1,3.7,5.256v1.626a1.4,1.4,0,0,1-1.4,1.4Z",
    transform: "translate(8.827 7.168)",
    fill: "#ed2f59",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.af16af8e46d6f917307f9a068fcb4015.svg";
export { ForwardRef as ReactComponent };